import { StoreUsersState, User } from '@/types';

export const SET_USERS = 'SET_USERS';

export default {
  [SET_USERS]: (state: StoreUsersState, payload: User[]): void => {
    state.users = payload;
  },
};
